import { render, staticRenderFns } from "./RankingEntry.vue?vue&type=template&id=3fa4798e&scoped=true"
import script from "./RankingEntry.vue?vue&type=script&lang=ts"
export * from "./RankingEntry.vue?vue&type=script&lang=ts"
import style0 from "./RankingEntry.vue?vue&type=style&index=0&id=3fa4798e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa4798e",
  null
  
)

export default component.exports